import { AssetTag, useFindByQuery } from '@gripp/shared-logic';
import { useEffect, useState } from 'react';

export const useAssetTags = (assetId: string) => {
  const [assetTags, setAssetTags] = useState<AssetTag[]>([]);

  const filter = {
    json: {
      'link.linkData.id': assetId,
    },
  };

  const { data } = useFindByQuery({
    modelName: 'tag',
    query: FIND_ASSET_TAGS,
    variables: { filter },
    options: {
      staleTime: 0,
      gcTime: 0,
    },
  });

  const isLoaded = data != null;

  useEffect(() => {
    if (!data) return;
    setAssetTags(data.items as AssetTag[]);
  }, [data]);

  return {
    assetTags,
    isLoaded,
  };
};

const FIND_ASSET_TAGS = `
    query FindTags($filter: TagFilter) {
      findTags(filter: $filter) {
        items {
          id
          tagCode
          status
        }
      }
    }
  `;
